export const runningDistanceOptions = [
  { label: "1 KM", value: "1 KM" },
  { label: "1.6 KM", value: "1.6 KM" },
  { label: "2 KM", value: "2 KM" },
  { label: "2.5 KM", value: "2.5 KM" },
  { label: "3 KM", value: "3 KM" },
  { label: "3.5 KM", value: "3.5 KM" },
  { label: "4 KM", value: "4 KM" },
  { label: "4.5 KM", value: "4.5 KM" },
  { label: "5 KM", value: "5 KM" },
  { label: "5.8 KM", value: "5.8 KM" },
  { label: "6 KM", value: "6 KM" },
  { label: "6.2 KM", value: "6.2 KM" },
  { label: "7 KM", value: "7 KM" },
  { label: "10 KM", value: "10 KM" },
  { label: "11 KM", value: "11 KM" },
  { label: "11.6 KM", value: "11.6 KM" },
  { label: "12 KM", value: "12 KM" },
  { label: "12.5 KM", value: "12.5 KM" },
  { label: "14 KM", value: "14 KM" },
  { label: "15 KM", value: "15 KM" },
  { label: "16 KM", value: "16 KM" },
  { label: "18 KM", value: "18 KM" },
  { label: "20 KM", value: "20 KM" },
  { label: "21.1 KM", value: "21.1 KM" },
  { label: "23 KM", value: "23 KM" },
  { label: "25 KM", value: "25 KM" },
  { label: "28 KM", value: "28 KM" },
  { label: "30 KM", value: "30 KM" },
  { label: "31.6 KM", value: "31.6 KM" },
  { label: "32 KM", value: "32 KM" },
  { label: "35 KM", value: "35 KM" },
  { label: "37.5 KM", value: "37.5 KM" },
  { label: "42 KM", value: "42 KM" },
  { label: "50 KM", value: "50 KM" },
  { label: "55 KM", value: "55 KM" },
  { label: "56 KM", value: "56 KM" },
  { label: "60 KM Ultra", value: "60 KM Ultra" },
  { label: "65 KM", value: "65 KM" },
  { label: "75 KM", value: "75 KM" },
  { label: "89.9 KM", value: "89.9 KM" },
  { label: "90 KM", value: "90 KM" },
];

export const cyclingDistanceOptions = [
  { label: "500 MTR", value: "500 MTR" },
  { label: "1 KM", value: "1 KM" },
  { label: "3 KM", value: "3 KM" },
  { label: "4 KM", value: "4 KM" },
  { label: "8 KM", value: "8 KM" },
  { label: "10 KM", value: "10 KM" },
  { label: "20 KM", value: "20 KM" },
  { label: "21 KM", value: "21 KM" },
  { label: "25 KM", value: "25 KM" },
  { label: "50 KM", value: "50 KM" },
  { label: "100 KM", value: "100 KM" },
];

export const activityOptions = [
  { label: "Running", value: "running" },
  { label: "Cycling", value: "cycling" },
];
